import { InteracLinkEmailRequest } from 'vopay';
import { useEffect } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import { useDataFetchIndicator } from '..';

const hook = vopayApi.withApiHook(({ api }) => {
  return function usePostLinkInterac() {
    const source = axios.CancelToken.source();
    const [, setDataFetchingInfo] = useDataFetchIndicator();

    const linkInterac = async (requestParams: InteracLinkEmailRequest) => {
      try {
        setDataFetchingInfo(true, '', 'fullScreen');
        const response = await api.postLinkInteracEmail(requestParams, source);
        return response;
      } finally {
        setDataFetchingInfo(false);
      }
    };

    useEffect(() => {
      return () => {
        source.cancel();
      };
    }, []);

    return {
      linkInterac,
    };
  };
});

export default hook({});
